'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.footer', ['ngMaterial']).directive('fFooter', function () {
  var fFooter = {
    restrict: 'AE',
    controller: 'FooterController',
    template: require('./tpl.html'),
    replace: true,
    scope: {
      title: '@'
    },
    link: function link(scope, element, attrs) {}
  };

  return fFooter;
}).controller('FooterController', function ($scope, $mdSidenav, fSession, config) {
  $scope.fSession = fSession;
  $scope.config = config;
  $scope.config.date = new Date();
});


//////////////////
// WEBPACK FOOTER
// ./footer/index.js
// module id = 483
// module chunks = 0